import actions from './actions'
import mutations from './mutations'
import getters from './getters'

export default {
  state: {
    data: [],
    count: null,
    isLoading: false
  },
  actions,
  getters,
  mutations,
  namespaced: true
}
